import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  output,
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { ChecklistsListGlobalFilterForm } from './checklists-list-global-filter.form';

@Component({
  selector: 'qaroni-checklists-list-global-filter',
  templateUrl: './checklists-list-global-filter.component.html',
  styleUrl: './checklists-list-global-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChecklistsListGlobalFilterComponent
  extends ChecklistsListGlobalFilterForm
  implements OnInit
{
  readonly queryParamsChange = output<Params>();

  private route = inject(ActivatedRoute);

  private queryParams$ = this.route.queryParamMap;

  ngOnInit(): void {
    this.subs.add(this.queryParams$.subscribe(this.getQueryParams));
  }

  public onChange(event: MatSlideToggleChange): void {
    this.onlyCompanyWideValue = event.checked;
    const queryParamsEmit = { ...this.route.snapshot.queryParams };

    if (this.onlyCompanyWideValue) {
      queryParamsEmit['onlyCompanyWide'] = 'true';
      delete queryParamsEmit['departmentIds'];
    } else {
      delete queryParamsEmit['onlyCompanyWide'];
    }
    this.queryParamsChange.emit(queryParamsEmit);
  }

  public getQueryParams = (queryParamsMap: ParamMap) => {
    if (queryParamsMap.has('onlyCompanyWide')) {
      const onlyCompanyWideValue = queryParamsMap.get('onlyCompanyWide');
      const onlyCompanyWide =
        onlyCompanyWideValue === 'true'
          ? true
          : onlyCompanyWideValue === 'false'
            ? false
            : null;
      this.onlyCompanyWideValue = onlyCompanyWide;
    } else {
      this.resetOnlyCompanyWide();
    }
  };
}
